export default __webpack_public_path__ + "static/media/hero-level-3-chars-desk.c378f3f8.webp";